/**
 * For นิเทศระบบยา (`med_error`): each answer `0` requires a non-empty remark.
 * Returns true when every failed item has a trimmed remark (or there are no zeros).
 */
export function medErrorRemarksValidForWeek(
  answers: Array<string | null | undefined> | undefined,
  problems: Array<string | null | undefined> | undefined,
): boolean {
  const weekAnswers = answers ?? [];
  const weekProblems = problems ?? [];
  for (let i = 0; i < weekAnswers.length; i += 1) {
    if (weekAnswers[i] !== '0') continue;
    const note = weekProblems[i] ?? '';
    if (!String(note).trim()) return false;
  }
  return true;
}
